import styled from 'styled-components/macro'

const MageGridWrapper = styled('div')`
  margin-top: 24px;
  width: 100%;
`

export default MageGridWrapper
